export const CONSTANTS = {
  YERSON_LOGO_SOURCE:
    "https://yerson.s3.eu-central-1.amazonaws.com/assets/yerson_logo.svg",
  YERSON_BOTTOM_LOGO_SOURCE:
    "https://yerson.s3.eu-central-1.amazonaws.com/assets/yerson_bottom_high.png",
  YERSON_BOTTOM_LOGO_GREEN_COLOR: "#dab8ab",
};
